export class RaceScoring {
  raceId?: number;
  scoringDefinition?:  boolean;
  scoringFor?: number;
  itraPoints?: number;
  mountainLevel?: number;
  utmbQualifier?: string;
  finisherLevel?: number;
  nameOne?: string;
  valueOne?: number;

  constructor() {
    this.raceId = undefined;
    this.scoringDefinition = undefined;
    this.scoringFor = undefined;
    this.itraPoints = undefined;
    this.mountainLevel = undefined;
    this.utmbQualifier = undefined;
    this.finisherLevel = undefined;
    this.nameOne = undefined;
    this.valueOne = undefined;
  }
}